// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link {
  cursor: pointer !important;
}

.reset-default {
  padding: 0px !important;
}

.admin {
  display: flex;
}

.admin-title {
  margin-right: 10px;
}

.user-info {
  padding-left: 10px !important;
}

.user-id {
  height: 18px !important;
}

.az-img-user {
  cursor: pointer;
}

.cursor-on {
  cursor: pointer;
  font-size: 24px;
}

.m-tenant {
  margin-left: 0px;
  margin-right: 0px;
}

.tenant-info {
  margin-top: 5px !important;
}

.tenant-icon {
  font-size: 28px !important;
}

.icon-size {
  max-width: 60px !important;
  margin-left: 10px !important;
}

.r-10 {
  margin-right: 0px !important;
}

.text-center {
  text-align: center;
}

.username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 160px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/header/header.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,6BAAA;AAGJ;;AADA;EACI,uBAAA;AAIJ;;AAFA;EACI,eAAA;AAKJ;;AAHA;EACI,eAAA;EACA,eAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,iBAAA;AAOJ;;AALA;EACI,0BAAA;AAQJ;;AANA;EACI,0BAAA;AASJ;;AAPA;EACI,0BAAA;EACA,4BAAA;AAUJ;;AARA;EACI,4BAAA;AAWJ;;AARA;EACI,kBAAA;AAWJ;;AARA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAWJ","sourcesContent":[".nav-link {\n    cursor:  pointer !important;\n}\n\n.reset-default {\n    padding: 0px !important;\n}\n\n.admin {\n    display: flex;\n}\n.admin-title{\n    margin-right: 10px;\n}\n.user-info {\n    padding-left: 10px !important;\n}\n.user-id {\n    height: 18px !important;\n}\n.az-img-user{\n    cursor: pointer;\n}\n.cursor-on{\n    cursor: pointer;\n    font-size: 24px;\n}\n.m-tenant{\n    margin-left: 0px;\n    margin-right: 0px;\n}\n.tenant-info {\n    margin-top: 5px !important;\n}\n.tenant-icon{\n    font-size: 28px !important;\n}\n.icon-size {\n    max-width: 60px !important;\n    margin-left: 10px !important;\n}\n.r-10{\n    margin-right: 0px !important; \n}\n\n.text-center {\n    text-align: center;\n}\n\n.username {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    width: 160px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
